import React, { useRef } from 'react';

// `scenes` is the row's chapters (CourseContentView), one tab each.
export default function SceneTabsBar({ scenes, activeSceneId, onSelectScene }) {
  const scrollRef = useRef(null);

  const scrollBy = (amount) => {
    scrollRef.current?.scrollBy({ left: amount, behavior: 'smooth' });
  };

  return (
    <div className="flex items-center gap-2 mb-6">
      <button
        onClick={() => scrollBy(-220)}
        aria-label="Scroll scenes left"
        className="shrink-0 h-9 w-9 rounded-full bg-white border border-gray-200 shadow-sm flex items-center justify-center text-purple-600 hover:bg-gray-50"
      >
        ←
      </button>

      <div ref={scrollRef} className="flex-1 flex items-center gap-3 overflow-x-auto scroll-smooth py-1">
        {scenes.map((scene) => {
          const isActive = scene.id === activeSceneId;
          return (
            <button
              key={scene.id}
              onClick={() => onSelectScene(scene.id)}
              className={`relative shrink-0 flex flex-col items-center rounded-2xl px-7 py-3.5 min-w-[112px] font-extrabold transition-colors ${
                isActive
                  ? 'bg-orange-400 text-white shadow-md'
                  : 'bg-white text-gray-700 border-2 border-gray-100 hover:border-orange-300'
              }`}
            >
              <span className="text-[15px]">{scene.title}</span>
              {scene.coins > 0 && (
                <span
                  className={`mt-2 flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-extrabold ${
                    isActive ? 'bg-white/25 text-white' : 'bg-amber-100 text-amber-700'
                  }`}
                >
                  🪙 {scene.coins}
                </span>
              )}
            </button>
          );
        })}
      </div>

      <button
        onClick={() => scrollBy(220)}
        aria-label="Scroll scenes right"
        className="shrink-0 h-9 w-9 rounded-full bg-white border border-gray-200 shadow-sm flex items-center justify-center text-purple-600 hover:bg-gray-50"
      >
        →
      </button>
    </div>
  );
}
